var map = {
	"./editorBaseApi": 4858,
	"./editorBaseApi.js": 4858,
	"./editorSimpleWorker": 7798,
	"./editorSimpleWorker.js": 7798,
	"./editorWorker": 304,
	"./editorWorker.js": 304,
	"./editorWorkerHost": 6358,
	"./editorWorkerHost.js": 6358,
	"./findSectionHeaders": 9307,
	"./findSectionHeaders.js": 9307,
	"./getIconClasses": 7762,
	"./getIconClasses.js": 7762,
	"./languageFeatureDebounce": 4791,
	"./languageFeatureDebounce.js": 4791,
	"./languageFeatures": 2230,
	"./languageFeatures.js": 2230,
	"./languageFeaturesService": 501,
	"./languageFeaturesService.js": 501,
	"./languageService": 6123,
	"./languageService.js": 6123,
	"./languagesAssociations": 5996,
	"./languagesAssociations.js": 5996,
	"./languagesRegistry": 6995,
	"./languagesRegistry.js": 6995,
	"./markerDecorations": 886,
	"./markerDecorations.js": 886,
	"./markerDecorationsService": 453,
	"./markerDecorationsService.js": 453,
	"./model": 4830,
	"./model.js": 4830,
	"./modelService": 125,
	"./modelService.js": 125,
	"./resolverService": 7042,
	"./resolverService.js": 7042,
	"./semanticTokensDto": 9376,
	"./semanticTokensDto.js": 9376,
	"./semanticTokensProviderStyling": 9520,
	"./semanticTokensProviderStyling.js": 9520,
	"./semanticTokensStyling": 2891,
	"./semanticTokensStyling.js": 2891,
	"./semanticTokensStylingService": 8148,
	"./semanticTokensStylingService.js": 8148,
	"./textModelSync/textModelSync.impl": 1305,
	"./textModelSync/textModelSync.impl.js": 1305,
	"./textModelSync/textModelSync.protocol": 5628,
	"./textModelSync/textModelSync.protocol.js": 5628,
	"./textResourceConfiguration": 1504,
	"./textResourceConfiguration.js": 1504,
	"./treeSitterParserService": 5320,
	"./treeSitterParserService.js": 5320,
	"./treeViewsDnd": 2603,
	"./treeViewsDnd.js": 2603,
	"./treeViewsDndService": 6756,
	"./treeViewsDndService.js": 6756,
	"./unicodeTextModelHighlighter": 9887,
	"./unicodeTextModelHighlighter.js": 9887,
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi": 4858,
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi.js": 4858,
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker": 7798,
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker.js": 7798,
	"monaco-editor/esm/vs/editor/common/services/editorWorker": 304,
	"monaco-editor/esm/vs/editor/common/services/editorWorker.js": 304,
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost": 6358,
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost.js": 6358,
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders": 9307,
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders.js": 9307,
	"monaco-editor/esm/vs/editor/common/services/getIconClasses": 7762,
	"monaco-editor/esm/vs/editor/common/services/getIconClasses.js": 7762,
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce": 4791,
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce.js": 4791,
	"monaco-editor/esm/vs/editor/common/services/languageFeatures": 2230,
	"monaco-editor/esm/vs/editor/common/services/languageFeatures.js": 2230,
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService": 501,
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService.js": 501,
	"monaco-editor/esm/vs/editor/common/services/languageService": 6123,
	"monaco-editor/esm/vs/editor/common/services/languageService.js": 6123,
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations": 5996,
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations.js": 5996,
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry": 6995,
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry.js": 6995,
	"monaco-editor/esm/vs/editor/common/services/markerDecorations": 886,
	"monaco-editor/esm/vs/editor/common/services/markerDecorations.js": 886,
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService": 453,
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService.js": 453,
	"monaco-editor/esm/vs/editor/common/services/model": 4830,
	"monaco-editor/esm/vs/editor/common/services/model.js": 4830,
	"monaco-editor/esm/vs/editor/common/services/modelService": 125,
	"monaco-editor/esm/vs/editor/common/services/modelService.js": 125,
	"monaco-editor/esm/vs/editor/common/services/resolverService": 7042,
	"monaco-editor/esm/vs/editor/common/services/resolverService.js": 7042,
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto": 9376,
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto.js": 9376,
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling": 9520,
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling.js": 9520,
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling": 2891,
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling.js": 2891,
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService": 8148,
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService.js": 8148,
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl": 1305,
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl.js": 1305,
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol": 5628,
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol.js": 5628,
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration": 1504,
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration.js": 1504,
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService": 5320,
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService.js": 5320,
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd": 2603,
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd.js": 2603,
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService": 6756,
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService.js": 6756,
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter": 9887,
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter.js": 9887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7614;